module.exports = __webpack_public_path__ + "img/logo.ae48f486.png";